import { ISelectData } from 'components/atoms/SelectComponent';

import { EMatNemaDuvod } from 'enums/lei/matNemaDuvod';

export const leiMatNemaDuvodSelect: ISelectData[] = [
    {
        labelcz: 'NATURAL_PERSONS',
        value: EMatNemaDuvod.NATURAL_PERSONS
    },
    {
        labelcz: 'NO_KNOWN_PERSON',
        value: EMatNemaDuvod.NO_KNOWN_PERSON
    },
    {
        labelcz: 'NON_CONSOLIDATING',
        value: EMatNemaDuvod.NON_CONSOLIDATING
    },
    {
        labelcz: 'NON_PUBLIC',
        value: EMatNemaDuvod.NON_PUBLIC
    }
];
